export default "__VITE_ASSET__BXLxyP42__"